import { render, staticRenderFns } from "./gameStats.vue?vue&type=template&id=73e7a847&scoped=true"
import script from "./gameStats.vue?vue&type=script&lang=js"
export * from "./gameStats.vue?vue&type=script&lang=js"
import style0 from "./gameStats.vue?vue&type=style&index=0&id=73e7a847&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e7a847",
  null
  
)

export default component.exports